<template>
  <div>
    <div class="leasing-summary">
      <div class="leasing-summary__head">
        <div class="leasing-summary__title">
          {{ leasing.KPPL_Name ? leasing.KPPL_Name : "&#8212;" }}
        </div>
        <div v-if="leasing.KPPL_SupplierName" class="leasing-summary__supplier">
          {{ leasing.KPPL_SupplierName }}
        </div>
      </div>

      <div class="leasing-summary__metrics">
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Сумма расчета</div>
          <div class="leasing-summary__value">
            {{ leasing.Amount ? moneyMask(leasing.Amount) : "&#8212;" }}
          </div>
        </div>
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Аванс</div>
          <div class="leasing-summary__value">
            {{
              leasing.Adv
                ? moneyMask((leasing.Price * leasing.Adv) / 100)
                : "&#8212;"
            }}
          </div>
        </div>
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Срок лизинга</div>
          <div class="leasing-summary__value">
            {{ leasing.SL ? leasing.SL + " мес." : "&#8212;" }}
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4" v-if="leasing.StatusKP == 0">
      <!-- <div class="login-alert p-3 text-center mt-4">
        <div class="text-primary">Ваша заявка отправлена на одобрение!</div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div> -->

      <!-- <div class="leasings-alert leasings-warning p-3 mt-4">
        <div class="leasings-warning-title">
          Ваша заявка отправлена на одобрение.
        </div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div> -->

      <div class="leasings-alert leasings-success p-3 mt-4">
        <div class="leasings-success-title">
          Ваша заявка отправлена на одобрение!
        </div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div>

      <!-- <div class="leasings-alert leasings-danger p-3 mt-4">
        <div class="leasings-danger-title">
          Ваша заявка отправлена на одобрение.
        </div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div> -->

      <!-- <div class="leasings-alert leasings-info p-3 mt-4">
        <div class="leasings-info-title">
          Ваша заявка отправлена на одобрение.
        </div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div> -->

      <!-- <div class="leasings-alert leasings-primary p-3 mt-4">
        <div class="leasings-primary-title">
          Ваша заявка отправлена на одобрение.
        </div>
        <div>По завершению Вам будет направлена дополнительная информация.</div>
      </div> -->

      <!-- <div class="fw-bold mt-4">Шаг 1 из 3. Проверка документов</div>

      <div class="row mt-2">
        <div class="col-lg-8">
          Автоматическая проверка загруженных документов на соответствие
          формату, проверка корректности содержимого.
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-6">
          <div class="alert alert-success">
            В случае успешной проверки всех документов из первоначального
            списка, проверка переходит в завершающую стадию принятия решения по
            лизинговой сделке.
          </div>
        </div>
        <div class="col-lg-6">
          <div class="alert alert-danger">
            В случае, если документ не прошел автоматическую проверку, его
            необходимо подгрузить повторно, выполнив требования в описании к
            документу.
          </div>
        </div>
      </div>
      <ui-button :loading="loadingDoc" class="btn btn-ghost" @click="docs">
        Вернуться к сбору документов
      </ui-button> -->
    </div>

    <div v-if="leasing.StatusKP == 3">
      <!-- <div class="hr mt-3"></div> -->
      <!-- <div class="fw-bold mt-4">
        Шаг 2 из 3. Запрос дополнительной информации
      </div> -->

      <!-- <div class="row mt-2 mb-3">
        <div class="col-lg-12">
          Для принятия окончательного решения требуется предоставление
          дополнительной информации. Необходимо вернуться к этапу сбора
          документов и подгрузить запрошенные дополнительно материалы.
        </div>
      </div> -->

      <div class="leasings-alert leasings-warning p-3 mt-4 mb-4">
        <div class="leasings-warning-title">
          Запрос дополнительной информации!
        </div>
        <div>
          Для принятия окончательного решения требуется предоставление
          дополнительной информации. Необходимо вернуться к этапу сбора
          документов и подгрузить запрошенные дополнительно материалы.
        </div>
      </div>
      <ui-button :loading="loadingDoc" class="btn btn-base" @click="docs">
        Вернуться к сбору документов
      </ui-button>
    </div>

    <div v-if="leasing.StatusKP == 1">
      <!-- <div class="hr mt-3"></div> -->
      <!-- <div class="fw-bold mt-4">Шаг 3 из 3. Проверка завершена</div> -->

      <!-- <div class="row mt-2 mb-3">
        <div class="col-lg-12">
          Поздравляем! Компания "СТОУН-XXI" готова сотрудничать. Для уточнения
          одобренных условий в ближайшее время с Вами свяжется наш сотрудник:
        </div>
      </div> -->
      <!-- <div class="d-flex flex-wrap mb-4">
        <span class="text-nowrap me-1">Ваш персональный менеджер</span
        ><a class="text-nowrap" href="">Стоунов Иван Иванович</a>
      </div> -->
      <!-- <div class="mt-4 mb-4">
        <a class="d-flex align-items-center line-height-1_2" href=""
          ><i class="icon-download me-2"></i>Скачать финальное КП</a
        >
      </div> -->
      <!-- <ui-button :loading="loading" class="btn btn-base" @click="next">
        Акцептовать одобренные условия
      </ui-button> -->
      <!-- <div class="row mt-3">
        <div class="col-auto">
          <RouterLink class="text-decoration" to=""
            >Перейти к подписанию договора</RouterLink
          >
        </div>
        <div class="col-auto">
          <button class="text-decoration" to="">Отменить сделку</button>
        </div>
      </div> -->

      <div class="leasings-alert leasings-primary p-3 mt-4 mb-4">
        <div class="leasings-primary-title">Ваша заявка одобрена!</div>
        <div>
          Запросите текст договора для подписания. Ожидайте информацию о дате и
          времени поставки.
        </div>
      </div>

      <ui-button :loading="loading" class="btn btn-base" @click="next">
        Запросить договор лизинга для подписания
      </ui-button>
    </div>

    <div v-if="leasing.StatusKP == 2">
      <div class="leasings-alert leasings-danger p-3 mt-4">
        <div class="leasings-danger-title">Проверка завершена!</div>
        <div>
          К сожалению, на текущий момент компания "СТОУН-XXI" не готова
          подтвердить сделку на запрашиваемых условиях. Для более подробного
          ответа и обсуждения возможных действий в ближайшее время с Вами
          свяжется наш сотрудник.
        </div>
      </div>

      <!-- <div class="hr mt-3"></div> -->
      <!-- <div class="fw-bold mt-4">Шаг 3 из 3. Проверка завершена</div>

      <div class="row mt-2 mb-3">
        <div class="col-lg-12">
          К сожалению, на текущий момент компания “СТОУН-XXI” не готова
          подтвердить сделку на запрашиваемых условиях. Для более подробного
          ответа и обсуждения возможных действий в ближайшее время с Вами
          свяжется наш сотрудник:
        </div>
      </div>
      <div class="d-flex flex-wrap mb-4">
        <span class="text-nowrap me-1">Ваш персональный менеджер</span
        ><a class="text-nowrap" href="">Стоунов Иван Иванович</a>
      </div> -->
      <!-- <button class="btn btn-base" href="" disabled>
        Отправить новую заявку
      </button> -->
    </div>

    <div v-if="leasing?.pro && leasing?.pro?.message">
      <div class="leasings-alert leasings-primary p-3 mt-4">
        <div class="leasings-primary-title">Статус проверки:</div>
        <div>
          {{ leasing.pro.message }}
        </div>
      </div>
    </div>
  </div>
</template>




<script setup>
import { ref } from "vue";

import { postApi, moneyMask } from "@/run";

import { useRoute } from "vue-router";

// Получаем текущий маршрут
const route = useRoute();

const props = defineProps({
  leasing: {
    type: Object,
    required: true,
  },
  setStatus: {
    type: Function,
  },
});

const loading = ref(false);
const error = ref(false);
const next = () => {
  loading.value = true;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 3,
  }).then((response) => {
    if (response.error) {
      error.value = response.error;
    }

    response.Status && props.setStatus(response.Status);

    loading.value = false;
  });
};

const loadingDoc = ref(false);

const docs = () => {
  loadingDoc.value = true;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 1,
  }).then((response) => {
    response.Status && props.setStatus(response.Status);

    loadingDoc.value = false;
  });
};
</script>